import { ITableHeadCell } from 'components/@shared/TableRemotePagination/types';
import Typography from '@mui/material/Typography';
import getTransformedDate from 'utils/getTransformedDate';
import { HomePageResponseViewModel } from 'types/home-page';
import { TableSwitch } from 'components/@shared/TableSwitch';

interface Props {
    item: ITableHeadCell;
    rowData: HomePageResponseViewModel;
    onSetAsActive: (id: string) => void;
}

export const HomePageListCell = ({ rowData: data, item, onSetAsActive }: Props) => {
    const field = data[item.field as keyof Pick<HomePageResponseViewModel, 'isActive' | 'createdDate' | 'description'>];

    if (item.field === 'isActive') {
        const handleSetAsActive = () => onSetAsActive(data.id);
        return <TableSwitch isActive={field as boolean} disabled={field as boolean} onChange={handleSetAsActive} />;
    }

    if (item.field === 'updatedDate' || item.field === 'createdDate') {
        return <Typography variant="body2">{getTransformedDate(field as string, 'MM/DD/YYYY') || '--'}</Typography>;
    }

    if (item.field === 'description') {
        return <Typography variant="body2">{field || '--'}</Typography>;
    }

    return (
        <Typography noWrap variant="body2">
            {field || '--'}
        </Typography>
    );
};
